import axios from 'axios';

export const GRAPHQL_URL = '/graphql';

const configuredAxios = axios.create({
  baseURL: '/board/api/v1/messagebox',
});

export default configuredAxios;
